import { connect } from 'react-redux';

import {
  getSearchIsActive,
  getSearchResults,
  getSearchIsLoading,
  getSearchQuery,
  getIsRecent,
  getRecentSearchItems,
} from 'store/reducers/search';
import { setActive } from 'actions/search-actions';
import Results from './Results';

const mapStateToProps = (state) => {
  const results = getSearchResults(state);
  return {
    isActive: getSearchIsActive(state),
    stationResults: results.stations,
    genreResults: results.genres,
    moodResults: results.moods,
    podcastResults: results.podcasts,
    liveShowResults: results.liveShows,
    onDemandResults: results.onDemands,
    isLoading: getSearchIsLoading(state),
    isRecent: getIsRecent(state),
    query: getSearchQuery(state),
    hasRecentSearchItems: !!getRecentSearchItems(state).length,
  };
};

const mapDispatchToProps = {
  setActive,
};

export default connect(mapStateToProps, mapDispatchToProps)(Results);
